import { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/routers/constant'

const router: Array<RouteRecordRaw> = [
  {
    path: '/system/log',
    component: Layout,
    redirect: '/system/log/index',
    meta: {
      title: '日志管理',
      keepAlive: false,
      requiresAuth: true
    },
    children: [
      {
        path: 'index',
        name: 'SystemLogIndex',
        component: () => import('@/views/system/log/index.vue'),
        meta: {
          keepAlive: false,
          requiresAuth: true,
          title: '日志管理'
        }
      }
    ]
  }
]

export default router
